import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_PROMOTE_OR_SHARE_CHANNEL_AWARE_CTA = defineFcm('psf_promote_or_share_channel_aware_cta')
	.asJson(
		createShapeNormalizer({
			type: 'array',
			shape: {
				type: 'enum',
				values: ['facebook', 'whatsapp'] as const,
			},
		}),
	)
	.withDefault([])
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'psf promote-or-share share slide-up',
		description:
			'Channel-aware PSF CTA (productized plane): per-country list of arrival channels that get the prominent "Share on <channel>" primary CTA on the promote_or_share share slide-up, matched to the signer\'s current_medium. Empty = off. ⚠️ Deliberately empty in EVERY country for the Top-8 relaunch (CHANGE-99290) — the previously productized Facebook CTA (CHANGE-98150) was rolled back so both channels re-test V1 vs V2 from a clean control. Adding a channel back here before the relaunch concludes excludes that country from the experiment. Repopulate this and the template below once a winning layout is chosen.',
		// Empty for the duration of the relaunch, not just a placeholder: the admin seeds every newly
		// created row from this template, so a non-empty value here would silently productize the CTA in
		// whichever country someone adds a row for, and drop it out of the experiment.
		template: [],
	});
